import { CircularProgress } from '@mui/material'
import classNames from 'classnames'
import { TSuggest } from 'feature/registration/types'
import { Button } from 'ui'

import baseStyle from 'widget/DadataSelectInput/DadataSelectInput.module.scss'
import style from './DadataMultiSelectList.module.scss'

type DadataMultiSelectListProps = {
  isDadataSelectVisible: boolean
  suggests: TSuggest[]
  selectHandler: (item: TSuggest) => Promise<void>
  isLoadingSuggest: boolean
}

export function DadataMultiSelectList({
  isDadataSelectVisible,
  suggests,
  selectHandler,
  isLoadingSuggest,
}: DadataMultiSelectListProps) {
  return (
    <div
      className={classNames(
        baseStyle.selectList,
        isDadataSelectVisible && baseStyle.selectListVisible,
      )}
    >
      {isLoadingSuggest ? (
        <div className={style.loader}>
          <CircularProgress size={25} />
        </div>
      ) : (
        <ul>
          {suggests.map(item => (
            <Button
              key={`${item.address}-${item.fiasId}`}
              color='primary'
              variant='text'
              className={baseStyle.selectItem}
              onClick={async e => {
                e.stopPropagation()
                await selectHandler(item)
              }}
            >
              {item.address}
            </Button>
          ))}
        </ul>
      )}
    </div>
  )
}
